import { render, staticRenderFns } from "./nav-items.vue?vue&type=template&id=0af6e62c&scoped=true&lang=pug&"
import script from "./nav-items.vue?vue&type=script&lang=coffee&"
export * from "./nav-items.vue?vue&type=script&lang=coffee&"
import style0 from "./nav-items.vue?vue&type=style&index=0&id=0af6e62c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af6e62c",
  null
  
)

export default component.exports